import { createContext } from 'react';
// This context will hold the stateful values that cause re-renders.
export const ModalStateContext = createContext(null);
// This context will hold the stable dispatch functions.
export const ModalDispatchContext = createContext(null);
// This context will hold the modal registration functions.
export const ModalRegistrationContext = createContext(null);
